"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ObjectSerializer";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import Image from "next/image";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface SingleWaveDropVotesProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropVotes: React.FC<SingleWaveDropVotesProps> = t0 => {
  const $ = _c(53);
  const {
    drop
  } = t0;
  const {
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  let isUserVoteNegative;
  let shouldShowUserVote;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let userVote;
  if ($[0] !== drop.context_profile_context?.rating || $[1] !== drop.rating || $[2] !== drop.rating_prediction || $[3] !== drop.top_raters || $[4] !== drop.wave.voting_credit_type || $[5] !== isVotingEnded || $[6] !== isWinner) {
    const firstThreeVoters = drop.top_raters.slice(0, 3);
    const isPositive = drop.rating >= 0;
    const hasUserVoted = drop.context_profile_context?.rating !== undefined && drop.context_profile_context?.rating !== 0;
    userVote = drop.context_profile_context?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    shouldShowUserVote = (isVotingEnded || isWinner) && hasUserVoted;
    t4 = "tw-flex tw-items-center tw-flex-wrap tw-gap-y-2 tw-gap-x-6 tw-mt-0.5";
    const t6 = `tw-text-sm tw-font-bold tw-font-mono tw-tracking-tight ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
    let t7;
    if ($[15] !== drop.rating) {
      t7 = formatNumberWithCommas(drop.rating);
      $[15] = drop.rating;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== t6 || $[18] !== t7) {
      t8 = <span className={t6}>{t7}</span>;
      $[17] = t6;
      $[18] = t7;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== drop.rating || $[21] !== drop.rating_prediction) {
      t9 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} />;
      $[20] = drop.rating;
      $[21] = drop.rating_prediction;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    const t10 = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
    let t11;
    if ($[23] !== t10) {
      t11 = <span className="tw-text-sm tw-text-iron-500 tw-font-normal">{t10}{" "}{WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    if ($[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
      t5 = <div className="tw-flex tw-items-baseline tw-gap-x-2">{t8}{t9}{t11}</div>;
      $[25] = t11;
      $[26] = t8;
      $[27] = t9;
      $[28] = t5;
    } else {
      t5 = $[28];
    }
    t3 = "tw-flex tw-items-center tw-gap-2";
    t1 = "tw-flex tw-items-center -tw-space-x-2";
    t2 = firstThreeVoters.map(_temp);
    $[0] = drop.context_profile_context?.rating;
    $[1] = drop.rating;
    $[2] = drop.rating_prediction;
    $[3] = drop.top_raters;
    $[4] = drop.wave.voting_credit_type;
    $[5] = isVotingEnded;
    $[6] = isWinner;
    $[7] = isUserVoteNegative;
    $[8] = shouldShowUserVote;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = userVote;
  } else {
    isUserVoteNegative = $[7];
    shouldShowUserVote = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    userVote = $[14];
  }
  let t6;
  if ($[29] !== t1 || $[30] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== drop.raters_count) {
    t7 = formatNumberWithCommas(drop.raters_count);
    $[32] = drop.raters_count;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  const t8 = drop.raters_count === 1 ? "voter" : "voters";
  let t9;
  if ($[34] !== t8) {
    t9 = <span className="tw-text-iron-500 tw-font-normal">{t8}</span>;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t7 || $[37] !== t9) {
    t10 = <span className="tw-text-white tw-font-bold tw-text-sm">{t7}{" "}{t9}</span>;
    $[36] = t7;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t3 || $[41] !== t6) {
    t11 = <div className={t3}>{t6}{t10}</div>;
    $[39] = t10;
    $[40] = t3;
    $[41] = t6;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== drop.wave.voting_credit_type || $[44] !== isUserVoteNegative || $[45] !== shouldShowUserVote || $[46] !== userVote) {
    t12 = shouldShowUserVote && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{WAVE_VOTING_LABELS[drop.wave.voting_credit_type]}</span></span></div></div>;
    $[43] = drop.wave.voting_credit_type;
    $[44] = isUserVoteNegative;
    $[45] = shouldShowUserVote;
    $[46] = userVote;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  let t13;
  if ($[48] !== t11 || $[49] !== t12 || $[50] !== t4 || $[51] !== t5) {
    t13 = <div className={t4}>{t5}{t11}{t12}</div>;
    $[48] = t11;
    $[49] = t12;
    $[50] = t4;
    $[51] = t5;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  return t13;
};
function _temp(voter) {
  return <div key={voter.profile.handle}><Link href={`/${voter.profile.handle}`}>{voter.profile.pfp ? <div className="tw-relative tw-w-6 tw-h-6"><Image className="tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={resolveIpfsUrlSync(voter.profile.pfp)} alt="Recent voter" fill={true} sizes="24px" data-tooltip-id={`wave-voter-${voter.profile.handle}`} /></div> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" data-tooltip-id={`wave-voter-${voter.profile.handle}`} />}</Link><Tooltip id={`wave-voter-${voter.profile.handle}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></div>;
}